export enum ICargoGroupTabs {
  addNewCargoGroup = "1",
  cargoGroupTable = "2",
}
